import { render, staticRenderFns } from "./ExplorePetgeek.vue?vue&type=template&id=147a2b80&scoped=true&"
import script from "./ExplorePetgeek.vue?vue&type=script&lang=js&"
export * from "./ExplorePetgeek.vue?vue&type=script&lang=js&"
import style0 from "./ExplorePetgeek.vue?vue&type=style&index=0&id=147a2b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147a2b80",
  null
  
)

export default component.exports